<!-- EN CANCHA -->
<div class="match-card en-cancha" *ngIf="variant === 'en-cancha'">
  <div class="card-top">
    <span class="court-badge">Cancha {{match.court || '?'}}</span>
    <span class="category-badge" [style.background]="match.categoryColor">{{match.category}}</span>
    <span class="group-badge" *ngIf="match.groupName && match.groupName !== 'finales'">{{match.groupName}}</span>
    <span class="group-badge finals" *ngIf="match.groupName === 'finales'">Finales</span>
    <button class="qr-btn" *ngIf="match.code" (click)="onShowQr()" title="Ver QR árbitro">
      <svg viewBox="0 0 16 16" fill="currentColor" width="14" height="14">
        <rect x="1" y="1" width="6" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"/>
        <rect x="3" y="3" width="2" height="2"/>
        <rect x="9" y="1" width="6" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"/>
        <rect x="11" y="3" width="2" height="2"/>
        <rect x="1" y="9" width="6" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"/>
        <rect x="3" y="11" width="2" height="2"/>
        <rect x="9" y="9" width="2" height="2"/>
        <rect x="13" y="9" width="2" height="2"/>
        <rect x="9" y="13" width="2" height="2"/>
        <rect x="13" y="13" width="2" height="2"/>
      </svg>
    </button>
    <span class="live-indicator"></span>
  </div>
  <div class="card-players">
    <span class="player-name">{{player1Name}}</span>
    <span class="vs">vs</span>
    <span class="player-name">{{player2Name}}</span>
  </div>
  <div class="card-score">
    <span class="games-score">Juegos: {{gamesScore}}</span>
    <span class="current-game" *ngIf="currentScore">J{{currentGameNumber}}: {{currentScore}}</span>
  </div>
  <div class="progress-row" *ngIf="match.progressPercent !== undefined">
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="match.progressPercent"></div>
    </div>
    <span class="time-estimate">~{{match.estimatedMinutesLeft}} min</span>
  </div>
</div>

<!-- SIGUIENTE / EN ESPERA -->
<div class="match-card" [ngClass]="variant" *ngIf="variant === 'siguiente' || variant === 'espera'"
     [class.unavailable]="!match.playerAvailable"
     [class.recently-moved]="isRecentlyMoved">
  <div class="card-left">
    <ng-content select=".drag-handle"></ng-content>
    <span class="position-badge" [class.small]="variant === 'espera'">#{{position}}</span>
  </div>
  <div class="card-body">
    <div class="card-top">
      <span class="category-badge" [class.small]="variant === 'espera'"
            [style.background]="match.categoryColor">{{match.category}}</span>
      <span class="group-badge" [class.small]="variant === 'espera'"
            *ngIf="match.groupName && match.groupName !== 'finales'">{{match.groupName}}</span>
      <span class="group-badge finals" [class.small]="variant === 'espera'"
            *ngIf="match.groupName === 'finales'">Finales</span>
      <span class="time-badge" *ngIf="showScheduledTime && scheduledTime" [class.overdue]="isOverdue" [class.small]="variant === 'espera'">
        <svg class="time-icon" viewBox="0 0 16 16" fill="currentColor"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 4v4.5l3 1.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>{{scheduledTime}}
      </span>
      <span class="priority-badge" [class.small]="variant === 'espera'" [ngClass]="priorityClass">{{priorityLabel}}</span>
    </div>
    <div class="card-players" [class.compact]="variant === 'espera'">
      <span class="player-name">{{player1Name}}</span>
      <span class="vs">vs</span>
      <span class="player-name">{{player2Name}}</span>
    </div>
    <div class="card-actions" *ngIf="isAdmin">
      <button class="start-btn" *ngIf="match.playerAvailable"
              [class.small]="variant === 'espera'" (click)="onStartMatch()">
        {{variant === 'siguiente' ? 'Iniciar en Cancha' : 'Iniciar'}}
      </button>
      <button class="order-btn" [class.small]="variant === 'espera'" (click)="onSetOrder()"
              title="Cambiar posición en la cola">
        Set Orden
      </button>
    </div>
    <div class="card-warning" *ngIf="variant === 'siguiente' && !match.playerAvailable">
      Jugador en cancha
    </div>
  </div>
</div>

<!-- FINALIZADO -->
<div class="match-card finalizado" *ngIf="variant === 'finalizado'">
  <div class="card-body">
    <div class="card-top">
      <span class="category-badge small" [style.background]="match.categoryColor">{{match.category}}</span>
      <span class="group-badge small"
            *ngIf="match.groupName && match.groupName !== 'finales'">{{match.groupName}}</span>
      <span class="group-badge finals small"
            *ngIf="match.groupName === 'finales'">Finales</span>
      <span class="scores-inline">
        <span *ngFor="let score of matchScores" class="game-score">{{score}}</span>
      </span>
    </div>
    <div class="card-players compact">
      <span class="player-name" [class.winner]="isWinner1">{{player1Name}}</span>
      <span class="vs">vs</span>
      <span class="player-name" [class.winner]="isWinner2">{{player2Name}}</span>
    </div>
  </div>
</div>
